import { useTranslation } from "react-i18next";
import { API_URL } from "../../config";
import React, { useState } from "react";

export function CustomReimbursementAttachmentCommentView({
    dataFile = [],
    dataComment = [],
    editMode,
    onClickDelete,
    onClickEdit,
    embedded = false,
}) {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const hasFiles = dataFile && dataFile.length > 0;
    const hasComments = dataComment && dataComment.length > 0;

    const isReadOnlyProceeding = editMode === undefined && !onClickDelete && !onClickEdit;

    if (isReadOnlyProceeding && embedded) {
        if (!hasFiles && !hasComments) return null;

        return (
            <div style={{ marginTop: 14 }}>
                {hasFiles && (
                    <>
                        <div className="reimbursement-section-subtitle">Övriga underlag</div>
                        <div className="reimbursement-file-items">
                            {dataFile.map((item, index) => {
                                if (!item?.fileId) return null;
                                const fileName = item?.fileExtension || "Bilaga";
                                return (
                                    <a
                                        key={`attachment-embedded-${item?.fileId ?? index}`}
                                        href={`${API_URL}/file?id=${item.fileId}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-decoration-none"
                                    >
                                        <div className="reimbursement-file-item">
                                            <div className="reimbursement-file-left">
                                                <div className="reimbursement-file-icon">
                                                    <i className="bx bx-file" />
                                                </div>
                                                <div className="reimbursement-file-name">{fileName}</div>
                                            </div>
                                            <i className="bx bx-chevron-right reimbursement-file-arrow" />
                                        </div>
                                    </a>
                                );
                            })}
                        </div>
                    </>
                )}

                {hasComments && (
                    <div style={{ marginTop: hasFiles ? 14 : 0 }}>
                        <div className="reimbursement-section-subtitle">Kommentar</div>
                        <div className="reimbursement-fields" style={{ gap: 10 }}>
                            {dataComment.map((item, index) => (
                                <div key={`comment-embedded-${item?.id ?? index}`} className="reimbursement-field">
                                    <div className="reimbursement-field-value" style={{ fontWeight: 600 }}>
                                        {item?.comment || "-"}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    if (!hasFiles && !hasComments) return null;

    const canEdit = editMode !== true && (
        dataFile.some(f => f?.status === 'Förslag') ||
        dataComment.some(c => c?.status === 'Förslag')
    );

    return (
        <div style={{
            border: "1px solid #e0e0e0",
            borderRadius: 12,
            background: "#f5f0e8",
            marginBottom: 8,
        }}>
            {/* Header clickable */}
            <div
                onClick={() => setIsExpanded(prev => !prev)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 16px",
                    cursor: "pointer",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <i className="bx bx-paperclip" style={{ fontSize: 18, color: "#555" }} />
                    <span style={{ fontWeight: 500, color: "#333" }}>Övriga underlag</span>
                </div>
                <i
                    className={`bx ${isExpanded ? "bx-chevron-up" : "bx-chevron-down"}`}
                    style={{ fontSize: 20, color: "#555" }}
                />
            </div>

            {/* Contenido animado */}
            <div style={{
                maxHeight: isExpanded ? "600px" : "0px",
                overflow: "hidden",
                transition: "max-height 0.3s ease",
            }}>
                <div style={{ padding: "0 12px 12px 12px" }}>

                    {/* Recuadro blanco */}
                    <div style={{
                        background: "#ffffff",
                        borderRadius: 10,
                        padding: "12px 16px",
                        marginBottom: canEdit ? 10 : 0,
                        border: "1px solid #eeeeee",
                    }}>
                        {/* Archivos */}
                        {hasFiles && dataFile.map((item, index) => {
                            if (!item?.fileId) return null;
                            const fileName = item?.fileName || "Bilaga";
                            
                            return (
                                <div key={`attachment-${item?.fileId ?? index}`} style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: 8,
                                    marginBottom: index < dataFile.length - 1 ? 8 : 0,
                                }}>
                                    <span style={{ fontSize: 14, color: "#555", flexShrink: 0 }}>Övriga underlag:</span>
                                    <a
                                        href={`${API_URL}/file?id=${item.fileId}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            fontSize: 14, color: "#157553", textDecoration: "underline",
                                            minWidth: 0, overflow: "hidden", textOverflow: "ellipsis",
                                            whiteSpace: "nowrap", textAlign: "right",
                                        }}
                                    >
                                        {fileName}
                                    </a>
                                </div>
                            );
                        })}

                        {/* Divider entre archivos y comentarios */}
                        {hasFiles && hasComments && (
                            <div style={{ borderTop: "1px solid #eee", margin: "10px 0" }} />
                        )}

                        {/* Comentarios */}
                        {hasComments && dataComment.map((item, index) => (
                            <div key={`comment-${item?.id ?? index}`} style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 8,
                                marginBottom: index < dataComment.length - 1 ? 8 : 0,
                            }}>
                                <span style={{ fontSize: 14, color: "#555", flexShrink: 0 }}>Kommentar:</span>
                                <span style={{
                                    fontSize: 14, color: "#333",
                                    textAlign: "right",
                                    minWidth: 0, wordBreak: "break-word",
                                }}>
                                    {item?.comment || "-"}
                                </span>
                            </div>
                        ))}
                    </div>

                    {/* Botones */}
                    {canEdit && (
                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); onClickDelete(); }}
                                style={{
                                    flex: 1, padding: "14px 0", background: "#f0f0f0",
                                    border: "none", borderRadius: 8, cursor: "pointer",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}
                            >
                                <i className="bx bx-trash-alt" style={{ fontSize: 20, color: "#EB5757" }} />
                            </button>
                            <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); onClickEdit(); }}
                                style={{
                                    flex: 1, padding: "14px 0", background: "#f0f0f0",
                                    border: "none", borderRadius: 8, cursor: "pointer",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}
                            >
                                <i className="bx bxs-pencil" style={{ fontSize: 20, color: "#555" }} />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}